var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C10.866 14.5 14 11.366 14 7.5C14 3.63401 10.866 0.5 7 0.5C3.13401 0.5 0 3.63401 0 7.5C0 11.366 3.13401 14.5 7 14.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83098 4.7592L4.43528 6.61858H6.39036L4.80989 7.76975L5.41418 9.62912L3.83098 8.48068L2.24778 9.62912L2.85481 7.76975L1.27161 6.61858H3.22668L3.83098 4.7592Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29867 11.3411L7.83656 10.7723L7.15297 11.0375L7.54945 10.4223L7.08734 9.85082L7.79555 10.0395L8.19477 9.42426L8.23305 10.1571L8.94399 10.3457L8.25766 10.6082L8.29867 11.3411Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21772 9.67309L9.43647 8.97309L8.83765 8.54926L9.57046 8.53832L9.78647 7.83832L10.0244 8.53285L10.7572 8.52465L10.1693 8.96215L10.4044 9.65668L9.80561 9.23285L9.21772 9.67309Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4565 5.6372L10.1338 6.29618L10.6588 6.80751L9.9342 6.7036L9.61155 7.35986L9.48577 6.63798L8.75842 6.53407L9.4092 6.19228L9.28342 5.46767L9.80842 5.97899L10.4565 5.6372Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3179 3.6413L8.26321 4.37138L8.94407 4.64755L8.2304 4.82255L8.17844 5.55536L7.7929 4.93192L7.07922 5.10692L7.55227 4.54638L7.16399 3.92567L7.84485 4.20184L8.3179 3.6413Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.5caa96ac7fd7173b147a5365ca1f20e9.svg";
export { ForwardRef as ReactComponent };